export const NEW_SESSION_TITLE = "New Session";

export const GITHUB_LINK =
  "https://github.com/continuedev/continue/issues/new/choose";
export const DISCORD_LINK = "https://discord.com/invite/EfJEfdFnDQ";
